// Hindi translations
export const hi: Record<string, string> = {
  'menu.dashboard': 'डैशबोर्ड',
  'menu.orderNew': 'उत्पाद पंजीकरण',
  'menu.deliveryList': 'डिलीवरी सूची',
  'menu.delivery': 'डिलीवरी',
  'menu.receipt': 'रसीद/लेबल प्रिंट करें',
  'menu.definitions': 'परिभाषाएं',
  'menu.customers': 'ग्राहक',
  'menu.products': 'उत्पाद परिभाषाएं',
  'menu.pricing': 'मूल्य परिभाषाएं',
  'menu.tailoring': 'दर्जी कार्य',
  'menu.attributes': 'उत्पाद विशेषताएं',
  'menu.users': 'उपयोगकर्ता',
  'menu.productOrdering': 'उत्पाद क्रम',
  'menu.discounts': 'छूट परिभाषाएं',
  'menu.settings': 'सेटिंग्स',
  'menu.generalSettings': 'सामान्य सेटिंग्स',
  'menu.permissions': 'अनुमति प्रबंधन',
  'menu.subscription': 'सदस्यता',
  'menu.invoices': 'चालान प्रबंधन',
  'menu.expenses': 'व्यय प्रविष्टि',
  'menu.zReport': 'Z Report',
  'menu.reportsAndAccounting': 'रिपोर्ट और लेखा',
  'menu.systemAndCommunication': 'सिस्टम और संचार',
  'menu.reportsList': 'रसीद सूची',
  'menu.accountStatement': 'खाता विवरण',
  'menu.tickets': 'समर्थन अनुरोध',
  'menu.support': 'समर्थन',
  'menu.profile': 'प्रोफ़ाइल',
  'menu.logout': 'लॉग आउट',
  'menu.notifications': 'SMS/WhatsApp सूचनाएं',
  'menu.whatsappConnection': 'WhatsApp कनेक्शन',
  'menu.smsConnection': 'SMS कनेक्शन',
  'dashboard.title': 'डैशबोर्ड',
  'dashboard.todaySales': 'आज की बिक्री',
  'dashboard.totalOrders': 'कुल ऑर्डर',
  'dashboard.pendingDeliveries': 'लंबित डिलीवरी',
  'dashboard.activeCustomers': 'सक्रिय ग्राहक',
  'dashboard.recentOrders': 'हाल के ऑर्डर',
  'dashboard.viewAll': 'सभी देखें',
  'dashboard.quickActions': 'त्वरित कार्य',
  'dashboard.newOrder': 'नया ऑर्डर',
  'dashboard.newCustomer': 'नया ग्राहक',
  'dashboard.deliveries': 'डिलीवरी',
  'dashboard.reports': 'रिपोर्ट',
  'dashboard.today': 'आज',
  'dashboard.yesterday': 'कल',
  'dashboard.week': 'सप्ताह',
  'dashboard.month': 'महीना',
  'dashboard.quarter': 'तिमाही',
  'dashboard.year': 'वर्ष',
  'dashboard.totalRevenue': 'कुल राजस्व',
  'dashboard.totalOrdersCard': 'कुल ऑर्डर',
  'dashboard.totalPieces': 'कुल आइटम',
  'dashboard.cancelled': 'रद्द किया गया',
  'dashboard.inProcess': 'प्रगति में',
  'dashboard.inProcessDesc': 'प्रगति में ऑर्डर',
  'dashboard.ready': 'तैयार',
  'dashboard.readyDesc': 'डिलीवरी के लिए तैयार ऑर्डर',
  'dashboard.delivered': 'डिलीवर किया गया',
  'dashboard.deliveredDesc': 'पूर्ण ऑर्डर',
  'dashboard.announcements': 'घोषणाएं',
  'dashboard.announcementAll': 'सामान्य',
  'dashboard.announcementPrivate': 'निजी',
  'order.title': 'नया ऑर्डर',
  'order.customer': 'ग्राहक',
  'order.selectCustomer': 'ग्राहक चुनें',
  'order.newCustomer': 'नया ग्राहक',
  'order.products': 'उत्पाद',
  'order.addProduct': 'उत्पाद जोड़ें',
  'order.selectProduct': 'उत्पाद चुनें',
  'order.quantity': 'मात्रा',
  'order.price': 'मूल्य',
  'order.total': 'कुल',
  'order.discount': 'छूट',
  'order.subtotal': 'उप-योग',
  'order.tax': 'कर',
  'order.grandTotal': 'कुल योग',
  'order.payment': 'भुगतान',
  'order.paymentMethod': 'भुगतान विधि',
  'order.cash': 'नकद',
  'order.card': 'क्रेडिट कार्ड',
  'order.credit': 'उधार',
  'order.amountPaid': 'भुगतान की गई राशि',
  'order.remainingBalance': 'शेष राशि',
  'order.deliveryDate': 'डिलीवरी तिथि',
  'order.notes': 'नोट्स',
  'order.createOrder': 'ऑर्डर बनाएं',
  'order.cancel': 'रद्द करें',
  'users.title': 'उपयोगकर्ता',
  'users.addNew': 'नया उपयोगकर्ता',
  'users.name': 'नाम',
  'users.email': 'ईमेल',
  'users.role': 'भूमिका',
  'users.pin': 'पिन',
  'users.permissions': 'अनुमतियां',
  'users.allPermissions': 'सभी अनुमतियां',
  'users.permissionCount': '{count} अनुमतियां',
  'users.changePin': 'पिन बदलें',
  'users.edit': 'संपादित करें',
  'users.delete': 'हटाएं',
  'users.newUser': 'नया उपयोगकर्ता',
  'users.editUser': 'उपयोगकर्ता संपादित करें',
  'users.editingUser': '{name} संपादित कर रहे हैं',
  'users.deleteUserTitle': 'उपयोगकर्ता हटाएं',
  'users.deletingUser': 'क्या आप वाकई {name} को हटाना चाहते हैं?',
  'users.pinCode': 'पिन कोड (4-6 अंक)',
  'users.selectRole': 'भूमिका चुनें',
  'users.patron': 'मालिक',
  'users.kasiyer': 'कैशियर',
  'users.sofor': 'चालक',
  'users.eleman': 'कर्मचारी',
  'users.changePinTitle': 'पिन कोड बदलें',
  'users.newPin': 'नया पिन कोड',
  'users.confirmPin': 'पिन कोड की पुष्टि करें',
  'users.pinMismatch': 'पिन कोड मेल नहीं खाते',
  'users.pinRequired': 'पिन कोड आवश्यक है',
  'users.pinLength': 'पिन कोड 4-6 अंकों का होना चाहिए',
  'users.changingPinFor': '{name} के लिए पिन बदल रहे हैं',
  'products.title': 'उत्पाद परिभाषाएं',
  'products.addNew': 'नया उत्पाद',
  'products.category': 'श्रेणी',
  'products.name': 'उत्पाद नाम',
  'products.price': 'मूल्य',
  'products.color': 'रंग',
  'products.active': 'सक्रिय',
  'products.actions': 'कार्य',
  'products.search': 'उत्पाद खोजें...',
  'products.noProducts': 'कोई उत्पाद नहीं मिला',
  'products.noCategoryProducts': 'इस श्रेणी में कोई उत्पाद नहीं',
  'products.emptyCart': 'कार्ट खाली है',
  'service.tailor': 'दर्जी',
  'service.dryCleaning': 'ड्राई क्लीनिंग',
  'service.washing': 'धुलाई',
  'service.ironing': 'इस्त्री',
  'service.shoeShine': 'जूता पॉलिश',
  'service.carpet': 'कालीन',
  'service.tailoring': 'दर्जी सुधार',
  'service.carpetWashing': 'कालीन धुलाई',
  'service.sofaWashing': 'सोफा धुलाई',
  'service.carWash': 'कार वॉश और डिटेलिंग',
  'service.barber': 'नाई / हेयर सैलून',
  'service.selectService': 'सेवा चुनें',
  'service.addToCart': 'कार्ट में जोड़ें',
  'service.total': 'कुल',
  'common.yes': 'हाँ',
  'common.no': 'नहीं',
  'common.cancel': 'रद्द करें',
  'common.confirm': 'पुष्टि करें',
  'common.delete': 'हटाएं',
  'common.edit': 'संपादित करें',
  'common.save': 'सहेजें',
  'common.search': 'खोजें',
  'common.loading': 'लोड हो रहा है...',
  'common.noData': 'कोई डेटा नहीं',
  'common.actions': 'कार्य',
  'common.status': 'स्थिति',
  'common.date': 'तारीख',
  'common.time': 'समय',
  'common.total': 'कुल',
  'common.filter': 'फ़िल्टर',
  'common.export': 'निर्यात',
  'common.print': 'प्रिंट',
  'common.close': 'बंद करें',
  'common.back': 'वापस',
  'common.next': 'Next',
  'common.previous': 'Previous',
  'common.submit': 'सबमिट करें',
  'common.reset': 'रीसेट करें',
  'common.create': 'बनाएं',
  'common.creating': 'बना रहे हैं...',
  'common.later': 'बाद में',
  'common.clear': 'साफ़ करें',
  'common.copied': 'कॉपी किया गया!',
  'common.copyError': 'कॉपी विफल',
  'common.autoDetected': 'स्वचालित रूप से पहचाना गया',
  'common.perPage': 'Per Page',
  'common.page': 'Page',
  'common.orders': 'Orders',
  'common.pieces': 'pieces',
  'login.title': 'Cleandy',
  'login.subtitle': 'ड्राई क्लीनिंग प्रबंधन प्रणाली',
  'login.tenantId': 'कंपनी आईडी',
  'login.tenantPlaceholder': 'कंपनी-आईडी (उदा: acme-clean)',
  'login.tenantIdHelp': 'अपनी विशिष्ट कंपनी पहचानकर्ता दर्ज करें',
  'login.continue': 'जारी रखें →',
  'login.notMember': 'अभी तक सदस्य नहीं हैं?',
  'login.startTrial': 'निःशुल्क परीक्षण शुरू करें',
  'login.adminLogin': '🔒 व्यवस्थापक लॉगिन',
  'login.enterPin': 'अपना पिन कोड दर्ज करें',
  'login.changeTenant': 'कंपनी बदलें',
  'login.clear': 'साफ़ करें',
  'login.delete': 'हटाएं',
  'login.login': 'लॉगिन',
  'login.loggingIn': 'लॉगिन हो रहा है...',
  'login.defaultPinOwner': 'डिफ़ॉल्ट पिन: <strong>1234</strong> (मालिक)',
  'login.defaultPinCashier': 'डिफ़ॉल्ट पिन: <strong>0000</strong> (कैशियर)',
  'login.systemInitializing': 'सिस्टम प्रारंभ हो रहा है...',
  'login.pinMinLength': 'पिन कम से कम 4 अंकों का होना चाहिए',
  'login.invalidTenantId': 'मान्य कंपनी आईडी दर्ज करें',
  'login.tenantNotFound': 'यह कंपनी कोड नहीं मिला। जांचें या नया खाता बनाएं।',
  'login.loginFailed': 'लॉगिन विफल',
  'login.welcome': '&X',
  'login.tagline': 'Dry cleaning software — Smart and easy solutions for your business.',
  'signup.title': 'निःशुल्क परीक्षण शुरू करें',
  'signup.subtitle': '15 दिन निःशुल्क, क्रेडिट कार्ड की आवश्यकता नहीं',
  'signup.backToLogin': 'लॉगिन पृष्ठ पर वापस जाएं',
  'signup.companyCode': 'कंपनी कोड',
  'signup.companyCodePlaceholder': 'उदा: cleanpro',
  'signup.companyCodeHelp': 'यह कोड सिस्टम में लॉगिन के लिए उपयोग किया जाएगा',
  'signup.companyCodeMinLength': 'कंपनी कोड कम से कम 3 वर्णों का होना चाहिए',
  'signup.companyName': 'कंपनी का नाम',
  'signup.companyNamePlaceholder': 'आपकी कंपनी का नाम',
  'signup.companyNameRequired': 'कंपनी का नाम आवश्यक है',
  'signup.fullName': 'पूरा नाम',
  'signup.fullNamePlaceholder': 'आपका पूरा नाम',
  'signup.fullNameRequired': 'पूरा नाम आवश्यक है',
  'signup.phone': 'फ़ोन',
  'signup.phonePlaceholder': '+91 98765 43210',
  'signup.validPhoneRequired': 'मान्य फ़ोन नंबर दर्ज करें',
  'signup.email': 'ईमेल',
  'signup.emailPlaceholder': 'example@company.com',
  'signup.validEmailRequired': 'मान्य ईमेल पता दर्ज करें',
  'signup.createAccount': 'खाता बनाएं',
  'signup.creating': 'बना रहे हैं...',
  'signup.businessType.question': 'आपका व्यवसाय क्या है?',
  'signup.businessType.hint': 'आपका डिफ़ॉल्ट स्क्रीन आपकी पसंद के अनुसार स्वचालित रूप से सेट होगा',
  'signup.businessType.continue': 'जारी रखें',
  'signup.bt.dryCleaning.desc': 'कपड़े, पर्दे और कपड़ा सफाई',
  'signup.bt.carpetWashing.desc': 'कालीन, किलिम और रनर की धुलाई',
  'signup.bt.shoeShine.desc': 'जूते की सफाई और देखभाल',
  'signup.bt.sofaWashing.desc': 'सोफा, कनापे और आर्मचेयर की धुलाई',
  'signup.bt.carWash.desc': 'वाहन धुलाई, पॉलिशिंग और देखभाल',
  'signup.bt.tailoring.desc': 'दर्जी, परिवर्तन और सिलाई सेवाएं',
  'signup.bt.barber.desc': 'नाई, हेयर सैलून और ब्यूटी पार्लर',
  'signup.terms': 'खाता बनाकर, आप सेवा की शर्तों और गोपनीयता नीति से सहमत होते हैं।',
  'signup.success': 'पंजीकरण सफल! आपकी लॉगिन जानकारी आपके ईमेल पते पर भेज दी गई है।',
  'signup.successTitle': 'पंजीकरण सफल!',
  'signup.successMessage': 'आपका खाता सफलतापूर्वक बनाया गया।',
  'signup.emailSent': 'आपकी लॉगिन जानकारी आपके ईमेल पते पर भेज दी गई है।',
  'signup.redirecting': 'लॉगिन पृष्ठ पर पुनर्निर्देशित किया जा रहा है...',
  'signup.startupPackageLoaded': 'स्टार्टअप पैकेज लोड किया गया!',
  'signup.products': 'उत्पाद',
  'signup.customers': 'ग्राहक',
  'signup.users': 'उपयोगकर्ता',
  'signup.demoDataReady': '✨ आपका डेमो डेटा तैयार है, आप तुरंत उपयोग शुरू कर सकते हैं!',
  'signup.loginInfo': '📧 आपकी लॉगिन जानकारी',
  'signup.loginInfoSent': '💡 यह जानकारी आपके ईमेल पते पर भी भेजी गई है',
  'signup.loginNow': 'अभी लॉगिन करें →',

  // गुम सामान्य कुंजियाँ
  'common.allYears': 'सभी वर्ष',
  'common.autoDetected': 'स्वचालित रूप से पता लगाया गया',
  'common.back': 'वापस',
  'common.cancelled': 'रद्द किया गया',
  'common.clear': 'साफ़ करें',
  'common.create': 'बनाएं',
  'common.creating': 'बना रहे हैं...',
  'common.items': 'आइटम',
  'common.later': 'बाद में',
  'common.loadError': 'लोड नहीं हो सका',
  'common.none': 'कोई नहीं',
  'common.paid': 'भुगतान किया गया',
  'common.searchError': 'खोज त्रुटि',
  'common.searchResults': '(खोज परिणाम)',
  'common.submit': 'जमा करें',
  'common.unit': 'इकाई',
  'common.year': 'वर्ष',

  // खाता विवरण
  'accountStatement.allTime': 'सभी समय',
  'accountStatement.customer': 'ग्राहक',
  'accountStatement.customerReceipts': 'ग्राहक रसीदें',
  'accountStatement.noData': 'कोई खाता विवरण नहीं मिला',
  'accountStatement.noReceipts': 'कोई रसीद नहीं मिली',
  'accountStatement.payments': 'भुगतान',
  'accountStatement.period': 'अवधि',
  'accountStatement.printStatement': 'विवरण प्रिंट करें',
  'accountStatement.receipts': 'रसीदें',
  'accountStatement.remaining': 'शेष राशि',
  'accountStatement.statement': 'खाता विवरण',
  'accountStatement.totalPaid': 'कुल भुगतान',

  // ग्राहक विवरण
  'customerStatement.receiptDelivered': 'डिलीवर किया गया',
  'customerStatement.receiptOpen': 'खुला',

  // ग्राहक
  'customers.add': 'ग्राहक जोड़ें',
  'customers.adres': 'पता',
  'customers.notFound': 'ग्राहक नहीं मिला',
  'customers.telefon': 'फ़ोन',
  'customers.telefon2': 'फ़ोन 2',

  // क्षति
  'damage.add': 'क्षति जोड़ें',
  'damage.description': 'विवरण',
  'damage.location': 'स्थान',
  'damage.noPhoto': 'कोई फोटो नहीं',
  'damage.photo': 'फोटो',
  'damage.saveError': 'क्षति रिपोर्ट सहेजी नहीं जा सकी',
  'damage.saved': 'क्षति रिपोर्ट सहेजी गई',
  'damage.severity': 'गंभीरता',
  'damage.title': 'क्षति रिपोर्ट',
  'damage.type': 'क्षति प्रकार',

  // डैशबोर्ड
  'dashboard.allTime': 'सभी समय',
  'dashboard.referral.button': 'आमंत्रण लिंक कॉपी करें',
  'dashboard.referral.desc': 'आमंत्रित व्यवसाय के साइन अप करने पर 1 महीना अतिरिक्त!',
  'dashboard.referral.title': 'दोस्तों को आमंत्रित करें',

  // डिलीवरी
  'delivery.complete': 'डिलीवर करें',
  'delivery.deliveredItems': 'डिलीवर किए गए आइटम',
  'delivery.error': 'डिलीवरी त्रुटि',
  'delivery.noOrders': 'कोई ऑर्डर नहीं मिला',
  'delivery.success': 'डिलीवरी सफल',

  // डिलीवरी सूची
  'deliveryList.address': 'पता',
  'deliveryList.cancelTitle': 'ऑर्डर रद्द करें',
  'deliveryList.complete': 'पूर्ण करें',
  'deliveryList.completed': 'पूर्ण हो गया',
  'deliveryList.delivered': 'डिलीवर किया गया',
  'deliveryList.driver': 'ड्राइवर',
  'deliveryList.items': 'आइटम',
  'deliveryList.orderCancelled': 'ऑर्डर रद्द किया गया',
  'deliveryList.orderDelivered': 'ऑर्डर डिलीवर किया गया',
  'deliveryList.pending': 'लंबित',
  'deliveryList.phone': 'फ़ोन',
  'deliveryList.selectDriver': 'ड्राइवर चुनें',
  'deliveryList.status': 'स्थिति',
  'deliveryList.title': 'डिलीवरी सूची',

  // ड्राइवर
  'driver.searchHint': 'कम से कम 2 अक्षर दर्ज करें',
  'driver.searchPlaceholder': 'रसीद नंबर, नाम या फ़ोन...',

  // फ़ुटर
  'footer.euServers': 'EU सर्वर',
  'footer.gdpr': 'GDPR अनुपालन',

  // चालान
  'invoices.downloading': 'डाउनलोड हो रहा है...',

  // लॉगिन
  'login.credentialsTitle': 'प्रमाण-पत्र',
  'login.enterCredentials': 'प्रमाण-पत्र दर्ज करें',
  'login.forget': 'पासवर्ड भूल गए?',
  'login.saveCredentialsNote': 'प्रमाण-पत्र सुरक्षित रूप से सहेजे गए',
  'login.tagline': 'ड्राई क्लीनिंग सॉफ़्टवेयर — आपके व्यवसाय के लिए स्मार्ट समाधान।',
  'login.usernamePlaceholder': 'उपयोगकर्ता नाम दर्ज करें...',

  // मेनू
  'menu.driverPickup': 'ड्राइवर पिकअप',
  'menu.hardware': 'हार्डवेयर',
  'menu.payment': 'भुगतान',
  'menu.reportsCharts': 'रिपोर्ट और चार्ट',

  // नेविगेशन
  'nav.logout': 'लॉग आउट',
  'nav.user': 'उपयोगकर्ता',

  // ऑर्डर
  'order.amount': 'राशि',
  'order.homeDelivery': 'होम डिलीवरी',
  'order.processing': 'प्रोसेस हो रहा है...',
  'orderCreate.selectOperation': 'कार्य चुनें',
  'orderCreate.selectedOperations': 'चयनित कार्य',

  // भुगतान
  'payment.bank': 'बैंक ट्रांसफर',
  'payment.collect': 'वसूली',
  'payment.credit': 'उधार',
  'payment.free': 'मुफ्त',
  'payment.paymentCare': 'खाता भुगतान',
  'payment.paymentsSaved': 'भुगतान सहेजे गए',
  'payment.saveError': 'भुगतान सहेजे नहीं जा सके',
  'payment.saved': 'भुगतान सहेजा गया',
  'payment.split': 'विभाजित भुगतान',

  // प्लेसहोल्डर
  'placeholder.customerAddress': 'पता दर्ज करें...',
  'placeholder.customerEmail': 'ईमेल दर्ज करें...',
  'placeholder.customerName': 'नाम दर्ज करें...',
  'placeholder.customerNotes': 'नोट्स दर्ज करें...',
  'placeholder.customerPhone': 'फ़ोन दर्ज करें...',

  // मूल्य निर्धारण
  'pricing.amount': 'राशि',
  'pricing.enterPrice': 'मूल्य दर्ज करें',
  'pricing.percent': 'प्रतिशत',

  // उत्पाद
  'product.damage': 'क्षति',
  'product.stain': 'दाग',

  // रसीद
  'receipt.addressLabel': 'पता',
  'receipt.allYears': 'सभी वर्ष',
  'receipt.area': 'क्षेत्रफल',
  'receipt.backButton': 'वापस',
  'receipt.buyCredits': 'क्रेडिट खरीदें',
  'receipt.cancelled': 'रद्द किया गया',
  'receipt.cancelledBanner': 'यह ऑर्डर रद्द कर दिया गया है',
  'receipt.cancelledBy': 'द्वारा रद्द किया गया',
  'receipt.cancelledDate': 'रद्द करने की तारीख',
  'receipt.cancelledReason': 'रद्द करने का कारण',
  'receipt.card': 'कार्ड',
  'receipt.cash': 'नकद',
  'receipt.change': 'वापसी राशि',
  'receipt.creditsFinished': 'WhatsApp क्रेडिट समाप्त हो गए!',
  'receipt.customer': 'ग्राहक',
  'receipt.customerInfo': 'ग्राहक जानकारी',
  'receipt.customerName': 'ग्राहक का नाम',
  'receipt.deliveryDate': 'डिलीवरी तारीख',
  'receipt.discount': 'छूट',
  'receipt.freeOfCharge': 'मुफ्त',
  'receipt.generalTotal': 'कुल योग',
  'receipt.grandTotal': 'अंतिम योग',
  'receipt.homeDelivery': 'होम डिलीवरी',
  'receipt.invalid': 'अमान्य रसीद',
  'receipt.items': 'आइटम',
  'receipt.label': 'लेबल',
  'receipt.markAsDelivered': 'डिलीवर किया गया के रूप में चिह्नित करें',
  'receipt.markAsReady': 'तैयार के रूप में चिह्नित करें',
  'receipt.messageFailed': 'संदेश भेजने में विफल',
  'receipt.messageSent': 'संदेश भेजा गया!',
  'receipt.new': 'नई रसीद',
  'receipt.noReceiptFound': 'कोई रसीद नहीं मिली',
  'receipt.notes': 'नोट्स',
  'receipt.onlyProEnterprise': 'केवल Pro/Enterprise',
  'receipt.orderMarkedDelivered': 'ऑर्डर डिलीवर किया गया के रूप में चिह्नित',
  'receipt.orderMarkedReady': 'ऑर्डर तैयार के रूप में चिह्नित',
  'receipt.orderNumber': 'ऑर्डर नंबर',
  'receipt.paid': 'भुगतान किया गया',
  'receipt.partialPayment': 'आंशिक भुगतान',
  'receipt.paymentMethod': 'भुगतान विधि',
  'receipt.phone': 'फ़ोन',
  'receipt.phoneNotFound': 'फ़ोन नंबर नहीं मिला',
  'receipt.piece': 'नग',
  'receipt.preview': 'पूर्वावलोकन',
  'receipt.printError': 'प्रिंट त्रुटि',
  'receipt.printerConnectError': 'प्रिंटर से कनेक्ट नहीं हो सका',
  'receipt.remaining': 'शेष राशि',
  'receipt.remainingCredits': 'शेष क्रेडिट',
  'receipt.reprint': 'पुनः प्रिंट',
  'receipt.scanQR': 'QR कोड स्कैन करें',
  'receipt.searchAll': 'सभी',
  'receipt.searchBy': 'खोज के अनुसार',
  'receipt.searchName': 'ग्राहक का नाम',
  'receipt.searchPhone': 'फ़ोन',
  'receipt.searchReceipt': 'रसीद नंबर',
  'receipt.searchTitle': 'रसीद खोजें',
  'receipt.sessionNotFound': 'सत्र नहीं मिला। कृपया फिर से लॉगिन करें।',
  'receipt.status': 'स्थिति',
  'receipt.thermalPrinter': 'थर्मल प्रिंटर',
  'receipt.thisReceiptCancelled': 'यह रसीद रद्द कर दी गई है',
  'receipt.unknownError': 'अज्ञात त्रुटि',
  'receipt.whatsappNotConnected': 'WhatsApp कनेक्ट नहीं है!',
  'receipt.year': 'वर्ष',

  // रिपोर्ट
  'reports.averageOrder': 'औसत ऑर्डर',
  'reports.ordersCount': 'ऑर्डर की संख्या',
  'reports.salesReport': 'बिक्री रिपोर्ट',
  'reports.totalSales': 'कुल बिक्री',

  // सेवाएं
  'service.carpetShort': 'कालीन',
  'service.dryCleaningShort': 'ड्राई क्लीनिंग',
  'service.ironingShort': 'इस्त्री',
  'service.shoeShineShort': 'जूते',
  'service.tailoringShort': 'दर्जी',
  'service.washingShort': 'धुलाई',

  // सेटिंग्स
  'settings.africa': 'अफ्रीका',
  'settings.americas': 'अमेरिका',
  'settings.asia': 'एशिया',
  'settings.asiaPacific': 'एशिया-प्रशांत',
  'settings.europe': 'यूरोप',
  'settings.integrations': 'इंटीग्रेशन',
  'settings.notifications': 'सूचनाएं',
  'settings.printer': 'प्रिंटर',
  'settings.printerConnected': 'प्रिंटर कनेक्ट है',
  'settings.printerNotConnected': 'प्रिंटर कनेक्ट नहीं है',
  'settings.printerSettings': 'प्रिंटर सेटिंग्स',
  'settings.saveError': 'सेटिंग्स सहेजी नहीं जा सकीं',
  'settings.saved': 'सेटिंग्स सहेजी गईं',
  'settings.testPrint': 'टेस्ट प्रिंट',
  'settings.turkey': 'तुर्की',

  // साइनअप
  'signup.errors.companyCodeRequired': 'कंपनी कोड आवश्यक है',
  'signup.errors.companyNameRequired': 'कंपनी का नाम आवश्यक है',
  'signup.errors.emailInvalid': 'अमान्य ईमेल पता',
  'signup.errors.emailRequired': 'ईमेल आवश्यक है',
  'signup.errors.ownerNameRequired': 'मालिक का नाम आवश्यक है',
  'signup.errors.signupFailed': 'पंजीकरण विफल',
  'signup.referral.bonus': 'रेफरल बोनस',
  'signup.referral.title': 'आमंत्रण कोड',

  // स्थिति
  'status.cancelled': 'रद्द किया गया',
  'status.delivered': 'डिलीवर किया गया',
  'status.pending': 'लंबित',
  'status.pickup_in_progress': 'पिकअप जारी है',
  'status.pickup_pending': 'पिकअप लंबित',
  'status.ready': 'तैयार',
  'status.received': 'प्राप्त',

  // सदस्यता
  'subscription.buyNow': 'अभी खरीदें',
  'subscription.cancel': 'सदस्यता रद्द करें',
  'subscription.contactSupport': 'सहायता से संपर्क करें',
  'subscription.currentPlan': 'वर्तमान प्लान',
  'subscription.currentUsage': 'वर्तमान उपयोग',
  'subscription.daysLeft': 'दिन शेष',
  'subscription.endDate': 'समाप्ति तिथि',
  'subscription.expired': 'समाप्त हो गया',
  'subscription.expiresOn': 'समाप्ति तिथि',
  'subscription.features': 'सुविधाएं',
  'subscription.loading': 'सदस्यता लोड हो रही है...',
  'subscription.monthly': 'मासिक',
  'subscription.monthlyLimit': 'मासिक सीमा',
  'subscription.noSubscription': 'कोई सक्रिय सदस्यता नहीं',
  'subscription.payNow': 'अभी भुगतान करें',
  'subscription.plan': 'प्लान',
  'subscription.pro': 'Pro',
  'subscription.renew': 'नवीनीकरण',
  'subscription.renewNow': 'अभी नवीनीकरण करें',
  'subscription.startDate': 'आरंभ तिथि',
  'subscription.title': 'सदस्यता',
  'subscription.trial': 'परीक्षण',
  'subscription.trialDaysLeft': 'परीक्षण दिन शेष',
  'subscription.upgrade': 'अपग्रेड',
  'subscription.yearly': 'वार्षिक',

  // सहायता टिकट
  'tickets.title': 'सहायता टिकट',
  'tickets.newTicket': 'नया टिकट',
  'tickets.noTickets': 'कोई टिकट नहीं मिला',
  'tickets.subject': 'विषय',
  'tickets.description': 'विवरण',
  'tickets.created': 'सहायता टिकट बनाया गया',
  'tickets.createError': 'टिकट नहीं बनाया जा सका',
  'tickets.loadError': 'टिकट लोड नहीं हो सके',
  'tickets.messages': 'संदेश',
  'tickets.typeMessage': 'संदेश टाइप करें...',
  'tickets.closed': 'बंद',
  'tickets.admin': 'व्यवस्थापक',
  'tickets.ratingSubmitted': 'रेटिंग सहेजी गई, धन्यवाद!',
  'tickets.translationError': 'अनुवाद त्रुटि',
  'tickets.status.open': 'खुला',
  'tickets.status.closed': 'बंद',
  'tickets.rating.veryBad': 'बहुत बुरा',
  'tickets.rating.bad': 'बुरा',
  'tickets.rating.okay': 'ठीक',
  'tickets.rating.good': 'अच्छा',
  'tickets.rating.excellent': 'उत्कृष्ट',

  // Toast सूचनाएं
  'toast.customerSaved': 'ग्राहक सहेजा गया',
  'toast.logoTooLarge': 'लोगो फ़ाइल बहुत बड़ी है',
  'toast.logoUploadError': 'लोगो अपलोड नहीं हो सका',
  'toast.priceUpdated': 'मूल्य अपडेट किया गया',
  'toast.uploadingLogo': 'लोगो अपलोड हो रहा है...',

  // WhatsApp
  'whatsapp.title': 'WhatsApp',
  'whatsapp.connect': 'WhatsApp कनेक्ट करें',
  'whatsapp.disconnect': 'डिसकनेक्ट',
  'whatsapp.connected': 'कनेक्ट है',
  'whatsapp.scanQR': 'QR कोड स्कैन करें',
  'whatsapp.status': 'स्थिति',
  'whatsapp.credits': 'क्रेडिट',
  'whatsapp.buyCredits': 'क्रेडिट खरीदें',
  'whatsapp.creditPackages': 'क्रेडिट पैकेज',
  'whatsapp.messages': 'संदेश',
  'whatsapp.creditsRemaining': 'शेष क्रेडिट',
  'whatsapp.noCredits': 'कोई क्रेडिट नहीं',
  'whatsapp.sendTest': 'टेस्ट संदेश भेजें',
  'whatsapp.testSent': 'टेस्ट संदेश भेजा गया',
  'whatsapp.testFailed': 'टेस्ट संदेश भेजने में विफल',
  'whatsapp.templates': 'टेम्पलेट',
  'whatsapp.template': 'टेम्पलेट',
  'whatsapp.preview': 'पूर्वावलोकन',
  'whatsapp.save': 'टेम्पलेट सहेजें',
  'whatsapp.saved': 'टेम्पलेट सहेजा गया',
  'whatsapp.orderReady': 'ऑर्डर तैयार',
  'whatsapp.orderDelivered': 'ऑर्डर डिलीवर हुआ',
  'whatsapp.receiptCreated': 'रसीद बनाई गई',

  // Z रिपोर्ट
  'zReport.title': 'Z रिपोर्ट',
  'zReport.byEmployee': 'कर्मचारी द्वारा',
  'zReport.byProduct': 'उत्पाद द्वारा',
  'zReport.byService': 'सेवा द्वारा',
  'zReport.cardPayments': 'कार्ड भुगतान',
  'zReport.cashIn': 'आय',
  'zReport.cashOut': 'व्यय',
  'zReport.cashPayments': 'नकद भुगतान',
  'zReport.closingBalance': 'समापन शेष',
  'zReport.creditPayments': 'उधार भुगतान',
  'zReport.custom': 'कस्टम',
  'zReport.daily': 'दैनिक',
  'zReport.endDate': 'समाप्ति तिथि',
  'zReport.freeOrders': 'मुफ्त ऑर्डर',
  'zReport.generateReport': 'रिपोर्ट बनाएं',
  'zReport.monthly': 'मासिक',
  'zReport.newCustomers': 'नए ग्राहक',
  'zReport.openingBalance': 'प्रारंभिक शेष',
  'zReport.printReport': 'रिपोर्ट प्रिंट करें',
  'zReport.returningCustomers': 'नियमित ग्राहक',
  'zReport.selectDate': 'तारीख चुनें',
  'zReport.serviceBreakdown': 'सेवावार विवरण',
  'zReport.startDate': 'आरंभ तिथि',
  'zReport.todayRegistrations': 'आज के पंजीकरण',
  'zReport.totalCollected': 'कुल संग्रह',
  'zReport.totalItems': 'कुल आइटम',
  'zReport.totalOrders': 'कुल ऑर्डर',
  'zReport.totalRefunds': 'कुल वापसी',
  'zReport.totalRevenue': 'कुल राजस्व',
  'zReport.transferPayments': 'ट्रांसफर भुगतान',
  'zReport.weekly': 'साप्ताहिक',
  'zreport.card': 'कार्ड',
  'zreport.cash': 'नकद',
  'zreport.date': 'तारीख',
  'zreport.orders': 'ऑर्डर',
  'zreport.print': 'प्रिंट',
  'zreport.title': 'Z रिपोर्ट',
  'zreport.total': 'कुल',
  'expenses.expenseType': 'व्यय प्रकार',
  'expenses.allBranches': 'सभी शाखाएं',
  'expenses.noBranch': 'कोई शाखा नहीं',
  'expenses.allTypes': 'सभी प्रकार',
  'expenses.categoryBy': 'श्रेणी के अनुसार',
  'expenses.records': 'रिकॉर्ड',
  'expenses.exportExcel': 'Excel',
  'expenses.excelError': 'Excel फ़ाइल नहीं बनाई जा सकी',
  'expenses.branchSelect': 'शाखा चुनें',
  'expenses.noBranchSelected': '— कोई शाखा नहीं चुनी —',
  'expenses.myBranch': 'मेरी शाखा',
  'expenses.canOnlyDeleteToday': 'आप केवल आज दर्ज किए गए व्यय हटा सकते हैं।',
  'subscription.referralDesc': 'जब आपका आमंत्रित मित्र साइन अप करके सदस्य बनता है, तो आपको 1 महीना अतिरिक्त मिलता है! केवल आमंत्रण भेजना पर्याप्त नहीं है।',
};
